export default __webpack_public_path__ + "static/media/queue_table.16db5f54.svg";